import { useTranslation } from 'react-i18next'

import {
  COMPANY_PAYMENT_METHODS,
  COMPANY_SETTINGS_PATH,
  DOCUMENT_PATH,
  PAYOUTS_PATH,
  TEAM_PATH,
  useGenerateCompanyPath,
} from '@/libs'

import { SidebarSection } from '@/components/ui/AppSidebar/SidebarSection'
import { SidebarLink } from '@/components/ui/AppSidebar/SidebarLink'
import { useCompaniesQuery } from '@/api/useCompaniesQuery'
import { Documents, Payouts } from '@/components/ui/AppSidebar/icons'
import { PaymentMethod } from '@/components/ui/AppSidebar/icons/PaymentMethod'
import { Team } from '@/components/ui/AppSidebar/icons/Team'
import { useParams } from 'react-router-dom'
import { ImageCompany } from '@/components/ui/AppSidebar/ImageCompany'
import { Skeleton } from '@dashboard/ui'
import { SidebarColumn } from '@/ui'
import { CompanyBuilding } from '@/components/ui/AppSidebar/icons/CompanyBuilding'

export const CompanySettingsSidebar = () => {
  const { t } = useTranslation()
  const { generatePath } = useGenerateCompanyPath()
  const { companyId } = useParams() as { companyId: string; gameId: string }
  const { data: dataCompanies } = useCompaniesQuery()
  const company = dataCompanies?.data?.find(it => it.id === companyId)

  const renderHeader = () => (
    <div className="flex items-center gap-3 rounded-md border border-border-primary bg-fg-primary p-0.5 shadow-xs">
      <div className="rounded-md border border-border-primary bg-fg-secondary p-0.5">
        <ImageCompany company={company} />
      </div>

      <div className="overflow-hidden">
        <div className="text-xs font-medium leading-none text-text-tertiary transition-colors group-hover:text-text-primary group-[&[data-open='true']]:text-text-primary">
          {t('sidebar.company-settings')}
        </div>
        <div className="mt-0.5 truncate text-sm font-semibold text-text-secondary">
          {company ? company.name : <Skeleton />}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <SidebarColumn header={renderHeader()}>
        <SidebarSection>
          <SidebarLink to={generatePath(DOCUMENT_PATH)} end={true} icon={Documents}>
            {t('sidebar.documents')}
          </SidebarLink>

          <SidebarLink to={generatePath(PAYOUTS_PATH)} end={true} icon={Payouts}>
            {t('sidebar.payouts')}
          </SidebarLink>

          <SidebarLink to={generatePath(COMPANY_PAYMENT_METHODS)} end={true} icon={PaymentMethod}>
            {t('sidebar.payment-methods')}
          </SidebarLink>

          <SidebarLink to={generatePath(TEAM_PATH)} end={false} icon={Team}>
            {t('sidebar.team')}
          </SidebarLink>

          <SidebarLink to={generatePath(COMPANY_SETTINGS_PATH)} end={true} icon={CompanyBuilding}>
            {t('sidebar.company-settings')}
          </SidebarLink>
        </SidebarSection>
      </SidebarColumn>
    </>
  )
}
